module.exports = __webpack_public_path__ + "img/main-promo-bg.f87b1ad.png";